<template>
  <g fill-rule="evenodd" fill="none">
    <path d="M-2-2h24v24H-2V-2z" />
    <path d="M7.5.5v19h-3V.5h3zm8 0v19h-3V.5h3z" fill-rule="nonzero" :fill="color" />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
